module.exports = __webpack_public_path__ + "img/om.ome5b8ab7.svg";